import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import css from './notification.module.css';

export default function Notification(
  text: string,
  show: boolean
): FormComponent {
  return ({ ...rest }) => (
    <NotificationComponent text={text} show={show} {...rest} />
  );
}

export function NotificationComponent({
  text,
  show,
}: FormComponentProps & {
  text: string;
  show: boolean;
}) {
  return show ? <div className={css['notification']}>{text}</div> : null;
}
